export const ResendEmailStatus = Object.freeze({
  Success: 0,
  UserNotFound: 1,
  UserAlreadyRegistered: 2,
  TimeoutIsNotPassed: 3
});
